import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Details from './pages/Details';
import Profile from './pages/Profile';
import ActivityLog from './pages/ActivityLog';
import NotFound from './pages/NotFound';
import ShortList from './pages/Shortlist';
import Campaigns from './pages/Campaigns';
import CampaignDetails from './pages/CampaignDetails';
import CampaignAnalysis from './pages/CampaignAnalysis';
import Loading from './pages/Loading';
import CustomGPT from './pages/CustomGPT';


function App() {
  return (
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/details" element={<PrivateRoute><Details /></PrivateRoute>} />
        <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
        <Route path="/activitylog" element={<PrivateRoute><ActivityLog /></PrivateRoute>} />
        <Route path="/shortlisted" element={<PrivateRoute><ShortList /></PrivateRoute>} />
        <Route path="/campaigns" element={<PrivateRoute><Campaigns /></PrivateRoute>} />
        <Route path="/campaignDetails" element={<PrivateRoute><CampaignDetails /></PrivateRoute>} />
        <Route path="/Loading" element={<PrivateRoute><Loading/></PrivateRoute>} />
        <Route path="/campaignAnalysis" element={<PrivateRoute><CampaignAnalysis /></PrivateRoute>} />
        <Route path="/support" element={<PrivateRoute><CustomGPT /></PrivateRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
  );
}

export default App;
